var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelpIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    fill: "none",
    viewBox: "0 0 17 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#627790",
    strokeLinecap: "round",
    strokeWidth: 1.4,
    d: "M8.5 11.997v.051"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#627790",
    strokeWidth: 1.2,
    d: "M8.5 16a7.5 7.5 0 100-15 7.5 7.5 0 000 15z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#627790",
    strokeWidth: 1.2,
    d: "M6.451 7.023a2.277 2.277 0 012.68-2.24c1.091.187 1.903 1.205 1.869 2.31-.029.95-.629 1.615-1.394 1.95-.71.315-1.106.557-1.106 1.332"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpIcon);
export default __webpack_public_path__ + "static/media/help-icon.823d98a9e9c5b95e6a17cb326c61ab24.svg";
export { ForwardRef as ReactComponent };